document.addEventListener("DOMContentLoaded", function () {
  const section = document.getElementById("recently-viewed-section");
  const wrapper = document.querySelector("#recently-viewed-slider-wrapper");
  const cookieName = "recently_viewed_products";
  const cookieMatch = document.cookie.match(
    "(^|;)\\s*" + cookieName + "\\s*=\\s*([^;]+)"
  );

  // Wenn kein Cookie vorhanden ist → Section ausblenden
  if (!cookieMatch) {
    section?.remove();
    return;
  }

  let products;
  try {
    products = JSON.parse(decodeURIComponent(cookieMatch[2]));
  } catch (e) {
    console.error("Invalid cookie:", e);
    section?.remove();
    return;
  }

  if (!products || !products.length) {
    section?.remove();
    return;
  }

  // HTML der Slider-Section von Shopify laden
  fetch("/?section_id=recently-viewed-products")
    .then((res) => res.text())
    .then((html) => {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;

      const sliderContainer = tempDiv.querySelector(
        "#recently-viewed-slider-html"
      );
      if (!sliderContainer) {
        section?.remove();
        return;
      }

      const slider = sliderContainer.querySelector("[data-slider]");
      const sliderContent = slider.querySelector(".simple-slider-container");
      const template = sliderContent.querySelector(".simple-slider-item");

      sliderContent.innerHTML = ""; // leeren

      products.forEach((product) => {
        if (!product.image || !product.handle || !product.title) return;

        const el = template.cloneNode(true);

        el.querySelectorAll("a").forEach(a => {
          let href = `/products/${product.handle}`;
          if (product.variant_id) {
            href += `#variant=${product.variant_id}`;
          }
          a.setAttribute("href", href);
          a.setAttribute("data-variant-link", "");
        });
        el.querySelector("img").src = product.image;
        el.querySelector("img").alt = product.title;
        el.querySelector(".product-type").textContent = product.subtitle || "";

        const titleElement = el.querySelector(".card__heading");
        if (titleElement) {
          titleElement.textContent = product.title;
        }

        const priceEl = el.querySelector(".product-price");

        const price = parseFloat(product.price);
        const compareAtPrice = parseFloat(product.sale_price); // sale_price = Vergleichspreis

        if (!isNaN(compareAtPrice) && compareAtPrice > price) {
          // Produkt ist reduziert
          priceEl.innerHTML = `
            <span class="product-price-sale">${formatMoney(price)}</span>
            <span class="product-price-old">${formatMoney(compareAtPrice)}</span>
          `;
        } else if (!isNaN(price)) {
          // Kein gültiger Vergleichspreis oder kein Rabatt
          priceEl.innerHTML = `${formatMoney(price)}`;
        } else {
          priceEl.innerHTML = "";
        }

        sliderContent.appendChild(el);
      });

      wrapper.innerHTML = ""; // Platzhalter leeren
      wrapper.appendChild(slider);
    })
    .catch((error) => {
      console.error("Error loading recently viewed section:", error);
      section?.remove();
    });

  function formatMoney(amount) {
    return new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
    }).format(amount);
  }
});
